import classNames from 'classnames';
import { ProjectUser } from 'src/features/projects/types/ProjectUser';

type AvatarProps = { label?: string; className?: string; title?: string };

const Avatar = ({ label, className, title }: AvatarProps): JSX.Element => (
  <div
    className={classNames(
      'flex items-center justify-center',
      'border border-solid border-grey-2',
      'bg-grey-3',
      'text-xs',
      'rounded-full',
      'h-10 w-10',
      'cursor-auto',
      className,
    )}
    title={title}
  >
    {label}
  </div>
);

type AvatarSetProps = { projectUsers: Array<ProjectUser> };

export const AvatarSet = ({ projectUsers }: AvatarSetProps): JSX.Element => (
  <div className="flex flex-row">
    {projectUsers.map(pu => (
      <Avatar key={pu.id} label={pu.initials} title={pu.name} className="-ml-1 first:ml-0" />
    ))}
  </div>
);
